(function () {
    'use strict';
    angular.module('app').controller('checkin', checkin);
    checkin.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', 'SelectionCommand_WorkflowService', 'selectionCommandService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService', 'zcs', 'extractionservice', 'requiredFieldsService', 'publishWaveService', 'favoritesService'];
    function checkin($location, scope, $rootScope, gridDataService, $q, SelectionCommand_WorkflowService, selectionCommandService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService, zcs, extractionservice, requiredFieldsService, publishWaveService, favoritesService) {

        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        scope.ACN_SIGN_IN = 101;
        scope.xyz = { bReadyForOK: false, bEnableLibPicker: true, selectedLibraryItem: {}, bKeepOut: false, bUndoCheckOut: false, bCreateVersion: false, bAllowUndoCheckOut: false };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];
        var _publishWaveData;
        var _updateRequiredFieldsForCheckOut = false;
        var _allRequiredFieldsCanceled = false;
        // =====================================
        // On Load. Assign To.
        // =====================================
        // Set the combo to 'building list'.
        scope.qualifiedUsersArrayLoading = function () {
            // If already on the 'building list', just leave it.
            if (scope.xyz.selectedUserItem != scope.qualifiedUsersBuildingList) {
                // Clear the array.
                scope.qualifiedUsersArray = [];
                // Add 'building list' to the array.
                scope.qualifiedUsersArray.push(scope.qualifiedUsersBuildingList);
                // Select 'building list' in the combo.
                scope.xyz.selectedUserItem = scope.qualifiedUsersBuildingList;
                // We are waiting for the items.
                scope.xyz.gettingUserList = true;
            }
        };
        // Load items into the combo. May be null.
        scope.qualifiedUsersArrayLoad = function (users) {
            // Clear the array.
            scope.qualifiedUsersArray = [];
            // Add 'pick one'.
            scope.qualifiedUsersArray.push(scope.qualifiedUsersPickOne);
            // Select 'pick one'.
            scope.xyz.selectedUserItem = scope.qualifiedUsersPickOne;
            // Add ''.
            scope.qualifiedUsersArray.push(scope.qualifiedUsersBlank);
            // If there are items, ...
            if (users != null) {
                // Walk the items, ...
                angular.forEach(users, function (name, id) {
                    // Add the item to the array.
                    scope.qualifiedUsersArray.push({ id: id, name: name })
                });
            }
            // We are done getting the items.
            scope.xyz.gettingUserList = false;
        }
        // Create a 'building list' item.
        scope.qualifiedUsersBuildingList = { id: 'building_list', name: "- " + loginService.resourceStrings["COMBO_BOX_BUILDING_LIST"] + " -" };
        // Create a 'pick one' item.
        scope.qualifiedUsersPickOne = { id: 'pick_one', name: "- " + loginService.resourceStrings["COMBO_BOX_PICK_ONE"] + " -" };
        // Create a '' item.
        scope.qualifiedUsersBlank = { id: '', name: '' };
        // Initailize to the 'building list' state.
        scope.qualifiedUsersArrayLoading();

        // =====================================
        //
        // =====================================  

        SelectionCommand_WorkflowService.GetAllowUndoCheckOut().then(function (response) {
            scope.xyz.bAllowUndoCheckOut = response.data;
        });

        //
        // Enables.
        //
        scope.doEnables = function () {
            // Handle enabling OK.
            scope.xyz.bReadyForOK = false;
            // Walk the grid's items.
            var len = scope.gridOptions.data.length;
            for (var i = 0; i < len; i++) {
                // Get this item.
                var gridItem = scope.gridOptions.data[i];
                if (gridItem.library == null)
                    return;
                if (gridItem.library.length < 1)
                    return;
            }
            scope.xyz.bReadyForOK = true;
        }

        //
        // On selection changed in the grid.
        //
        //scope.selectItem = function (item) {
        //    // Do Enables.
        //    scope.doEnables();
        //};

        // On click of the command.
        scope.onCheckInButtonClicked = function (slx) {
            // Ping ACS. On failure, close dialog.
            var name = start();
            zcs.Ping(true).then(function (response) {
                // List.
                scope.slx = slx;
                //console.log(name);
                //end(name, "ping");
                // Dialog config.
                scope.heading = loginService.resourceStrings["TITLE_CHECKIN"];
                scope.libraryLabel = loginService.resourceStrings["DESTINATION_LIBRARY"];
                scope.assignToLabel = loginService.resourceStrings["ASSIGN_TO"];
                scope.createVersionLabel = loginService.resourceStrings["CREATE_VERSION"];
                scope.keepOutLabel = loginService.resourceStrings["KEEP_OUT_LABEL"];
                scope.undoCheckOutLabel = loginService.resourceStrings["UNDO_CHECKOUT_LABEL"];
                scope.filesLabel = loginService.resourceStrings["FILES_TO_CHECKIN"];
                scope.OK = loginService.resourceStrings["OK"]; // "OK";
                scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel"; 

                // Dialog config columns.
                scope.gridOptions.columnDefs = [
                    { name: 'Name', field: 'name', width: '15%', minWidth: '100' },
                    { name: 'Library', field: 'library', width: '10%', minWidth: '100' },
                    { name: 'Status', field: 'status', width: '10%', minWidth: '100' },
                    { name: 'Assign To', field: 'assignTo', width: '10%', minWidth: '100' },
                    { name: 'File Changed', field: 'bFileHasChanged', width: '10%', minWidth: '100' },
                    { name: 'Data Card Changed', field: 'bDataCardHasChanged', width: '10%', minWidth: '100' },
                    { name: 'Undo Check Out', field: 'bUndoCheckOut', width: '10%', minWidth: '100' },
                    { name: 'Keep Out', field: 'bKeepOut', width: '10%', minWidth: '100' },
                    { name: 'Create Version', field: 'bCreateVersion', width: '10%', minWidth: '100' }
                ];
                var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
                var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
                scope.gridOptions.columnDefs[0].name = colName;
                scope.gridOptions.columnDefs[1].name = colLibrary;
                scope.gridOptions.columnDefs[2].name = loginService.resourceStrings["SCHEMA_S_STATUS"];
                scope.gridOptions.columnDefs[3].name = loginService.resourceStrings["ASSIGN_TO"];
                scope.gridOptions.columnDefs[4].name = loginService.resourceStrings["FILE_CHANGED"];
                scope.gridOptions.columnDefs[5].name = loginService.resourceStrings["DATA_CARD_CHANGED"];
                scope.gridOptions.columnDefs[6].name = loginService.resourceStrings["UNDO_CHECKOUT_LABEL"];
                scope.gridOptions.columnDefs[7].name = loginService.resourceStrings["KEEP_OUT_LABEL_SHORT"];
                scope.gridOptions.columnDefs[8].name = loginService.resourceStrings["CREATE_VERSION"];
                // Debug columns.
                //scope.bDebug = true;
                //if (scope.bDebug) {
                //    scope.gridOptions.columnDefs.push({ name: 'DBG - Prev UTC', field: 'previousUTC', width: '15%', minWidth: '100' });
                //    scope.gridOptions.columnDefs.push({ name: 'DBG - Curr UTC', field: 'currentUTC', width: '15%', minWidth: '100' });
                //}

                // Library picker.
                scope.libraryArray = [];
                //scope.libraryArray.push({ id: '7a76d2b1-68a9-4d54-9c40-124c7fafd2d7', name: 'AFS-Checked' });
                //scope.libraryArray.push({ id: '0bdb13a6-c548-4262-a84a-a817f9263ec2', name: 'AFS-Unchecked' });
                //scope.libraryArray.push({ id: 'e62256c5-cad0-4c7d-aedd-adb6ad9b530e', name: 'AFS-Unchecked-AutoRev' });

                // checkInOptionsList
                var checkInOptionsList = [];
                angular.forEach(scope.slx.list, function (item) {
                    checkInOptionsList.push({ fileId: item.fileId, libId: '' });
                });

                // Get options and add to grid.
                scope.gridOptions.data = [];

                SelectionCommand_WorkflowService.GetCheckInOptionsList(checkInOptionsList).then(function (response) {

                    // It is OK to keep this seperate because the response item is different than the selection item.
                    var fileInfoModelList = [];
                    scope.previousUTCs = [];
                    scope.bDataCardHasChanged = [];
                    scope.bWillCreateVersion = [];
                    scope.bCanCreateVersion = [];
                    angular.forEach(response.data, function (item) {
                        var fileId = item.fileId;
                        fileInfoModelList.push({ fileId: fileId, filePNE: item.filePNE, lastWriteTimeUTC: "" });
                        scope.previousUTCs[fileId] = item.previousUTC;
                        scope.bDataCardHasChanged[fileId] = item.bDataCardHasChanged;
                        scope.bWillCreateVersion[fileId] = item.bWillCreateVersion;
                        scope.bCanCreateVersion[fileId] = item.bCanCreateVersion;
                    });

                    // Get the file infos from the ACS.

                    zcs.GetFileInfos(fileInfoModelList).then(function (response) {
                        // Store them.
                        scope.currentUTCs = [];
                        angular.forEach(response, function (item) {
                            scope.currentUTCs[item.fileId] = item.lastWriteTimeUTC;
                        });

                        // For each selection item, add a row to the grid.
                        scope.gridOptions.data = [];
                        var index = 0;
                        angular.forEach(scope.slx.list, function (item) {
                            var previousUTC = scope.previousUTCs[item.fileId];
                            var currentUTC = scope.currentUTCs[item.fileId];
                            // Default Library
                            item.commandParams.eLibId = item.detailedInfo.libId;
                            // Add item.
                            scope.gridOptions.data.push({
                                index: index,
                                selectionItem: item,
                                isSelected: true,
                                fileId: item.fileId,
                                name: item.filename, library: item.detailedInfo.libName, status: item.detailedInfo.status, opFlag: item.detailedInfo.opFlag,
                                previousUTC: previousUTC,
                                currentUTC: currentUTC,
                                bKeepOut: 'F',
                                bFileHasChanged: previousUTC == currentUTC ? 'F' : 'T',
                                bDataCardHasChanged: scope.bDataCardHasChanged[item.fileId] ? 'T' : 'F',
                                bUndoCheckOut: 'F',
                                bWillCreateVersion: scope.bWillCreateVersion[item.fileId] ? 'T' : 'F',
                                bCanCreateVersion: scope.bCanCreateVersion[item.fileId] ? 'T' : 'F', bCreateVersion: 'F'
                            });
                            index++;

                            // ***** Process Children *****

                            // Get list of children Children.

                            // Make a list of children that are out to the current user.

                            // Call GetFileInfos for the OutList.

                            // Walk the OutList.

                            // If not already in the slx, 

                            // add them here, indented.
                            /*
                            previousUTC = "";
                            currentUTC = "";
                            var item = { fileId: "fileid", filename: "     child" };
                            item.detailedInfo = {};
                            item.detailedInfo.libName = "lib";
                            item.detailedInfo.status = "status";
                            item.detailedInfo.opFlag = "op";
                            item.detailedInfo.libId = "libid";
                            item.commandParams = {};
                            item.commandParams.eLibId = item.detailedInfo.libId;
       
                            // Add item.
                            scope.gridOptions.data.push({
                                index: index,
                                selectionItem: item,
                                isSelected: true,
                                fileId: item.fileId,
                                name: item.filename, library: item.detailedInfo.libName, status: item.detailedInfo.status, opFlag: item.detailedInfo.opFlag,
                                previousUTC: previousUTC,
                                currentUTC: currentUTC,
                                bKeepOut: 'F',
                                bFileHasChanged: previousUTC == currentUTC ? 'F' : 'T',
                                bDataCardHasChanged: 'F',
                                bUndoCheckOut: 'F',
                                bWillCreateVersion: 'F',
                                bCanCreateVersion: 'F',
                                bCreateVersion: 'F'
                            });
                            index++;
                            */

                        });

                        // Enables.
                        // let select all rows handle it - scope.selectItem();

                        // Select rows.
                        $timeout(function () {
                            refreshGrid();
                            scope.gridApi.selection.selectAllRows();
                            $timeout(function () {
                                refreshGrid();
                            }, 2000);
                        }, 500);

                    });
                });
            }, function (response) {
                // Handle error.
                $mdDialog.hide();
                $rootScope.msgBoxShow(loginService.resourceStrings["ACS_FAILED_TO_CONNECT"], loginService.resourceStrings["ACS_REQUIRED"]);
            });
        };

        // =====================================
        // User interaction.
        // =====================================

        //
        // On library change.
        //
        scope.selectedLibraryChanged = function (name, id, item) {
            scope.xyz.selectedLibraryItem = item;
            if (scope.xyz.selectedLibraryItem == null)
                return;

            //// EDGE-EMPTY
            //if (scope.xyz.selectedLibraryItem.name.length < 1) {
            //    var browserInfo = navigator.userAgent;
            //    var bIsEdge = browserInfo.indexOf('Edge/') != -1;
            //    if (bIsEdge)
            //        scope.xyz.selectedLibraryItem.name = '\u00A0';
            //}

            var O_DUP = 70; // 'F'; // OPFLAG.O_DUP
            var O_NEW = 81; // 'Q'; // OPFLAG._NEW

            // checkInOptionsList
            var checkInOptionsList = [];

            // Walk the grid's selected items.
            var len = scope.gridOptions.data.length;
            for (var i = 0; i < len; i++) {
                // Get this selected item.
                var gridItem = scope.gridOptions.data[i];
                //if (gridItem.isSelected) { // FOR TESTING
                if (gridItem.isSelected && (gridItem.opFlag == O_DUP || gridItem.opFlag == O_NEW)) {
                    if (!item.bIsFolder) {
                        checkInOptionsList.push({ fileId: gridItem.fileId, libId: scope.xyz.selectedLibraryItem.libId });
                        gridItem.library = scope.xyz.selectedLibraryItem.name;
                        gridItem.selectionItem.commandParams.eLibId = scope.xyz.selectedLibraryItem.libId; // *****
                    }
                    else {

                        gridItem.selectionItem.commandParams.eLibId = "";
                        gridItem.library = "";
                    }

                }
            }

            // Get options and add to grid.
            SelectionCommand_WorkflowService.GetCheckInOptionsList(checkInOptionsList).then(function (response) {

                scope.bWillCreateVersion = [];
                scope.bCanCreateVersion = [];
                angular.forEach(response.data, function (item) {
                    var fileId = item.fileId;
                    var will = item.bWillCreateVersion;
                    var can = item.bCanCreateVersion;
                    angular.forEach(scope.gridOptions.data, function (griditem) {
                        if (griditem.fileId == fileId) {
                            griditem.bWillCreateVersion = will ? 'T' : 'F';
                            griditem.bCanCreateVersion = can ? 'T' : 'F';
                        }
                    });
                });

                // Do Enables.
                //scope.doEnables();
                scope.selectItem(); // Rebuild Assign List too.
            });
        };

        //
        // On user change.
        //
        scope.selectedUserChanged = function () {
            // If nothing selected, then return.
            if (scope.xyz.selectedUserItem == null)
                return;
            // If user selected 'pick one', then return.
            if (scope.xyz.selectedUserItem == scope.qualifiedUsersPickOne)
                return;

            var nameForGrid = scope.xyz.selectedUserItem.name;
            // EDGE-EMPTY
            if (scope.xyz.selectedUserItem.name.length < 1) {
                var browserInfo = navigator.userAgent;
                var bIsEdge = browserInfo.indexOf('Edge/') != -1;
                if (bIsEdge) {
                    // scope.xyz.selectedUserItem.name = '\u00A0';
                    nameForGrid = '\u00A0';
                }
            }

            // Walk the grid's selected items.
            var len = scope.gridOptions.data.length;
            for (var i = 0; i < len; i++) {
                // Get this selected item.
                var gridItem = scope.gridOptions.data[i];
                if (gridItem.isSelected) {
                    gridItem.assignToUserId = scope.xyz.selectedUserItem.id;
                    gridItem.assignTo = nameForGrid; // scope.xyz.selectedUserItem.name;
                    gridItem.selectionItem.commandParams.eAssignToUserId = scope.xyz.selectedUserItem.id; // *****
                }
            }
            // Do Enables.
            scope.doEnables();
        };

        //
        // On check/uncheck of the Keep Out checkbox.
        //
        scope.keepOutCheckChanged = function () {
            // Walk the grid's selected items.
            var len = scope.gridOptions.data.length;
            for (var i = 0; i < len; i++) {
                // Get this selected item.
                var gridItem = scope.gridOptions.data[i];
                if (gridItem.isSelected) {
                    gridItem.bKeepOut = scope.xyz.bKeepOut ? "T" : "F";
                    gridItem.selectionItem.commandParams.ebKeepOut = scope.xyz.bKeepOut; // *****
                }
            }
            // Do Enables.
            scope.doEnables();
        };

        //
        // On check/uncheck of the Keep Out checkbox.
        //
        scope.undoCheckOutCheckChanged = function () {
            // Walk the grid's selected items.
            var len = scope.gridOptions.data.length;
            for (var i = 0; i < len; i++) {
                // Get this selected item.
                var gridItem = scope.gridOptions.data[i];
                if (gridItem.isSelected && gridItem.bFileHasChanged == 'F') {
                    gridItem.bUndoCheckOut = scope.xyz.bUndoCheckOut ? "T" : "F";
                    gridItem.selectionItem.commandParams.ebUndoCheckOut = scope.xyz.bUndoCheckOut; // *****
                }
            }
            // Do Enables.
            scope.doEnables();
        };

        //
        // On check/uncheck of the Create Version checkbox.
        //
        scope.createVersionCheckChanged = function () {
            // Walk the grid's selected items.
            var len = scope.gridOptions.data.length;
            for (var i = 0; i < len; i++) {
                // Get this selected item.
                var gridItem = scope.gridOptions.data[i];
                if (gridItem.isSelected && gridItem.bCanCreateVersion == 'T') {
                    gridItem.bCreateVersion = scope.xyz.bCreateVersion ? "T" : "F";
                    gridItem.selectionItem.commandParams.ebMakeRevision = scope.xyz.bCreateVersion; // *****
                }
            }
            // Do Enables.
            scope.doEnables();
        };

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function () {

            // Always set all items to not selected.
            angular.forEach(scope.gridOptions.data, function (item) {
                item.isSelected = false;
            });

            // Get the selected items.
            var bSomethingIsNew = false;
            var O_OUT = 83; // 'S'; // OPFLAG.O_OUT
            var items = [];
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (item) {
                item.isSelected = true;
                items.push(item.selectionItem);
                if (item.selectionItem.detailedInfo.opFlag != O_OUT)
                    bSomethingIsNew = true;
            });

            if (bSomethingIsNew)
                scope.xyz.bEnableLibPicker = true;
            else
                scope.xyz.bEnableLibPicker = false;

            // Build the SL with mode and order.
            var slx = { mode: 0, order: 0, list: items };

            // ============================
            // Select Item. Assign To.
            // ===========================+
            // Add users to the combo.
            scope.qualifiedUsersArrayLoading();
            if (items.length < 1) {
                scope.qualifiedUsersArrayLoad();
            }
            else {
                SelectionCommand_WorkflowService.GetUserListForAssign(slx, scope.ACN_SIGN_IN).then(function (response) {
                    scope.qualifiedUsersArrayLoad(response.data);
                }, function () {
                    scope.qualifiedUsersArrayLoad();
                });
            }

            // Do Enables.
            scope.doEnables();
        };

        // =====================================
        // OK, Cancel.
        // =====================================

        var GetFavoriteListIDByName = function (strFavoriteListName) {
            // Must be a promise.
            var deferred = $q.defer();
            favoritesService.getDefinitions(true).then(function (definitions) {
                var id = "";
                angular.forEach(definitions, function (definition) {
                    if (definition.name === strFavoriteListName)
                        id = definition.id;
                });
                deferred.resolve(id);
            });
            return deferred.promise;
        };

        var DeleteFavoriteListByName = function (strFavoriteListName) {
            // Must be a promise.
            var deferred = $q.defer();
            GetFavoriteListIDByName(strFavoriteListName).then(function (id) {
                if (id.length > 0) {
                    favoritesService.deleteFavoriteList(id).then(function () {
                        deferred.resolve();
                    });
                }
                else {
                    deferred.resolve();
                }
            });
            return deferred.promise;
        };

        var updateLastCheckInFavorites = function (userName, slx) {
            // Not deferred. Let this happen threaded.

            var rows = [];
            angular.forEach(slx.list, function (item) {
                if (item.updateSI !== null) {
                    var xtableNumber = item.updateSI.tableNumber;
                    var xfileId = item.updateSI.fileId;
                    var xmajRev = item.updateSI.majRev;
                    var xminRev = item.updateSI.minRev;
                    var row = { SCHEMA_S_SRCDB: xtableNumber, SCHEMA_S_FILEID: xfileId, SCHEMA_S_MAJREV: xmajRev, SCHEMA_S_MINREV: xminRev };
                    rows.push(row);
                }
            });

            var name = "_Last Check In by " + userName;
            var comment = "Checked In at: " + new Date();
            DeleteFavoriteListByName(name).then(function () {
                favoritesService.addFavoriteList(name, comment).then(function (containerModel) {
                    favoritesService.addItemsFavorite(containerModel.containerDefinition.id, rows).then(function () {
                        favoritesService.getDefinitions(true);
                    });
                });
            });
        };

        var checkInItem6_HandleResult = function (gridItem, selectionCommandResults) {
            // Must be a promise.
            var deferred = $q.defer();

            // Walk the list and add to our results list.
            angular.forEach(selectionCommandResults.slx.list, function (si) {
                scope.resultSLX.list.push(si);
            });
            angular.forEach(selectionCommandResults.ntfItemXfers, function (ntfItemXfer) {
                scope.resultNtfItemXfers.push(ntfItemXfer);
            });

            // Not deferred. Let this happen threaded.
            updateLastCheckInFavorites(loginService.userName, scope.resultSLX);

            // Final file ops.
            // Could be a delete item here.
            // Call ACS to do the file operation.
            var timeObj2 = start();
            zcs.ProcessFileOperationPacket(selectionCommandResults.fileOperationPacket, true).then(function (response) {
                //console.log(timeObj2);
                //end(timeObj2, "ProcessFileOperationPacket");
                deferred.resolve();
            }, function (response) {
                //in case of this ProcessFileOperationPacket exception
                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
            });

            return deferred.promise;
        }

        var checkInItem5_CheckInItem = function (gridItem) {
            // Must be a promise.
            var deferred = $q.defer();

            var timeObj = start();

            //if cancel all for all required fields has been selected, keep out needs to be set to false
            if (_allRequiredFieldsCanceled) {
                gridItem.bKeepOut = 'F';
            }


            // Call the WebApi to do the check-in.
            selectionCommandService.CheckInItem(
                gridItem.fileId, gridItem.selectionItem.commandParams.eLibId, gridItem.assignToUserId,
                gridItem.bUndoCheckOut == 'T' ? true : false,
                gridItem.bKeepOut == 'T' ? true : false,
                gridItem.bCreateVersion == 'T' ? true : false,
                scope.fileOperationModel
            ).then(function (response) {
                //console.log(timeObj);
                //end(timeObj, "CheckInItem");
                // When that  returns, ...
                var selectionCommandResults = response.data;

                //get the record UpdateSI
                var updateSI = selectionCommandResults.slx.list[0].updateSI;
                if (_updateRequiredFieldsForCheckOut) {
                    var record = {
                        tableNumber: updateSI.tableNumber,
                        fileId: updateSI.fileId,
                        majRev: updateSI.majRev,
                        minRev: updateSI.minRev,
                        filename: updateSI.filename,
                    }
                    // Second param: callUpdateDocument = true.  Should always call it if warranted.
                    requiredFieldsService.updateRecord(record, true).then(function () {
                        checkInItem6_HandleResult(gridItem, selectionCommandResults).then(function (response) {
                            deferred.resolve();
                        }, function (response) {
                            deferred.reject();
                        });
                    });
                }
                else {
                    checkInItem6_HandleResult(gridItem, selectionCommandResults).then(function (response) {
                        deferred.resolve();
                    }, function (response) {
                        deferred.reject();
                    });
                }              

            }, function (response) {
                //in case of selectionCommandService.CheckInItem exception
                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
            });

            return deferred.promise;
        }

        var checkInItem4_Extract = function (gridItem) {
            // Must be a promise.
            var deferred = $q.defer();

            //Only evaluate extraction for linked type
            var LT_LINKED = 76; // 'L'; ApiTypes.ADLINKTYPE.LT_LINKED
            //defect id: 25115 - added ec condition to ensure good return on the previous steps
            if (gridItem.selectionItem.detailedInfo.linkType == LT_LINKED) { //  && selectionCommandResults.slx.list[0].ec == 0
                //Instantiate an extraction object 
                extractionservice.extractionItem.tableNumber = gridItem.selectionItem.tableNumber; // selectionCommandResults.slx.list[0].updateSI.tableNumber;
                extractionservice.extractionItem.filePNE = scope.fileOperationModel.sourceFile;
                extractionservice.extractionItem.fileId = gridItem.selectionItem.fileId; // selectionCommandResults.slx.list[0].updateSI.fileId;
                extractionservice.extractionItem.fileMajRev = gridItem.selectionItem.majRev; // selectionCommandResults.slx.list[0].updateSI.majRev;
                extractionservice.extractionItem.fileMinRev = gridItem.selectionItem.minRev; // selectionCommandResults.slx.list[0].updateSI.minRev;
                //check detailedInfo for libid, if NOT ADEPT_NULL_ID then use it, otherwise use the commandParams eLibId
                if (gridItem.selectionItem.detailedInfo.libId != "ADEPT_NULL_LIBID" && gridItem.selectionItem.detailedInfo.libId != "") {
                    extractionservice.extractionItem.libId = gridItem.selectionItem.detailedInfo.libId;
                }
                else {
                    extractionservice.extractionItem.libId = gridItem.selectionItem.commandParams.eLibId;
                }
                var timeObj = start();
                //check if extraction is required
                extractionservice.extractionRequired(extractionservice.extractionItem.tableNumber, extractionservice.extractionItem.fileId, extractionservice.extractionItem.fileMajRev, extractionservice.extractionItem.fileMinRev, extractionservice.extractionItem.libId, gridItem.currentUTC).then(function (response) {
                    //console.log(timeObj);
                    //end(timeObj, "ExtractionRequired");
                    //on the return from the extraction check, promise to do the extraction
                    if (response.RequireExtraction || response.RequireFTSExtraction) {
                        //if extraction is required, make the call
                        var timeObj1 = start();
                        extractionservice.extractItem(extractionservice.extractionItem, response.RequireFTSExtraction).then(function (response) {
                            //console.log(timeObj1);
                            //end(timeObj1, "ExtractItem");
                            checkInItem5_CheckInItem(gridItem).then(function (response) {
                                deferred.resolve();
                            }, function (response) {
                                deferred.reject();
                            });
                        }, function (error) {
                            //in case of exception in extractionservice.extractItem
                            deferred.resolve(error);
                        }, function (response) {
                            //in case of this extractItem exception
                            selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                        });
                    }
                    else {
                        //if extraction is NOT required
                        checkInItem5_CheckInItem(gridItem).then(function (response) {
                            deferred.resolve();
                        }, function (response) {
                            deferred.reject();
                        });
                    }
                }, function (response) {
                    //in case of extractionrequired exception
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                });
            }
            //if not 'linked' type
            else {
                checkInItem5_CheckInItem(gridItem).then(function (response) {
                    deferred.resolve();
                }, function (response) {
                    deferred.reject();
                });
            }

            return deferred.promise;
        }


        var checkInItem3_Stage = function (gridItem, singleFileOperationPacket) {

            var timeObj = start();

            // Must be a promise.
            var deferred = $q.defer();

            // Do staging.
            var request = zcs.ProcessFileOperationPacket(singleFileOperationPacket, true);

            request.then(function (response) {
                //console.log(timeObj);
                //end(timeObj, "ProcessFileOperationPacket");
                // Pass the file operation to the WebApi because
                // the WebApi needs to know where we staged it,
                // and ACS added to it (File UTC).
                scope.fileOperationModel = null;
                if (response.data != null && response.data.fileOperations != null)
                    scope.fileOperationModel = response.data.fileOperations[0];

                checkInItem4_Extract(gridItem).then(function (response) {
                    deferred.resolve();
                }, function (response) {
                    deferred.reject();
                });

            }, function (response) {
                //in case of zcs.ProcessFileOperationPacket exception
                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
            });

            return deferred.promise;
        }

        var checkInItem2_PreCheckInItem = function (gridItem) {
            // Must be a promise.
            var deferred = $q.defer();

            //determine if extraction is necessary (different time/date stamp)
            //scope.currentUTCs[item.fileId] = item.lastWriteTimeUTC;

            // Pre check-in.
            var timeObj = start();
            selectionCommandService.PreCheckInItem(gridItem.fileId, gridItem.selectionItem.commandParams.eLibId).then(function (response) {

                //console.log(timeObj);
                //end(timeObj, "PreCheckInItem");
                // Handle any file ops for staging.

                var singleFileOperationPacket = null; // response.data.stagingFileOperationPacket;
                scope.fileOperationModel = null; // singleFileOperationPacket.fileOperations[0];
                if (response.data != null && response.data.stagingFileOperationPacket != null) {
                    singleFileOperationPacket = response.data.stagingFileOperationPacket;
                    scope.fileOperationModel = singleFileOperationPacket.fileOperations[0];
                }

                checkInItem3_Stage(gridItem, singleFileOperationPacket).then(function (response) {
                    deferred.resolve();
                }, function (response) {
                    deferred.reject();
                });

            }, function (response) {
                //in case of selectionCommandService.PreCheckInItem exception
                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
            });
            return deferred.promise;
        }

        // Do the work of one item.
        var checkInItem1_TestAccess = function (gridItem) {
            // Must be a promise.
            var deferred = $q.defer();

            var O_DUP = 70; // 'F'; // OPFLAG.O_DUP
            var O_NEW = 81; // 'Q'; // OPFLAG.O_NEW
            var O_OUT = 83; // 'S'; // OPFLAG.O_OUT
            var opFlag = gridItem.selectionItem.detailedInfo.opFlag;
            if (opFlag == O_DUP || opFlag == O_NEW || opFlag == O_OUT) {
                var timeObj = start();
                selectionCommandService.GetAccessPath(gridItem.selectionItem.tableNumber, gridItem.selectionItem.fileId, gridItem.selectionItem.majRev, gridItem.selectionItem.minRev).then(function (data) {
                    //console.log(timeObj);
                    //end(timeObj, "GetAccessPath");
                    var filePNE = data.accessPNE;
                    var timeObj1 = start();
                    zcs.TestAccess(filePNE, true).then(function (response) {
                        //console.log(timeObj1);
                        //end(timeObj1, "TestAsccess");
                        var bOK = response;
                        if (!bOK) {
                            var ec = 82; // ErrorCodes.ErrorCode.ECFILEBUSY
                            selectionCommandService.ErrorCode(gridItem.selectionItem, ec).then(function (response) {
                                scope.resultSLX.list.push(response.data);
                                deferred.resolve();
                            }, function (response) {
                                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                            });
                        }
                        else {
                            checkInItem2_PreCheckInItem(gridItem).then(function () {
                                // When it is done, we are done.
                                deferred.resolve();
                            }, function () {
                                deferred.resolve(); // Called function will not reject.
                            });
                        }
                    }, function (response) {
                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                    });
                }, function (response) {
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                });
            }
            else {
                checkInItem2_PreCheckInItem(gridItem).then(function () {
                    // When it is done, we are done.
                    deferred.resolve();
                }, function () {
                    deferred.resolve(); // Called function will not reject.
                });
            }

            return deferred.promise;
        }

        // Call back from the dialog.
        var questionBox_PostCloseCallback_DataCardChanged = function (param1, param2, result) {
            // Remember for next time.
            scope.answers.loseDataCardChanges = result;
            var gridItem = param1;
            var deferred = param2;
            // If we are to process the item, ...
            if (result == 'Y' || result == 'YtoAll') {
                // Do the work now.
                checkInItem1_TestAccess(gridItem).then(function () {
                    // When that is done, we are done.
                    deferred.resolve();
                }, function () {
                    deferred.resolve(); // Called function will not reject.
                });
            }
            else { // Or if we are not process it, ...
                // Then we are done.
                deferred.resolve();
            }
        }

        // Do one item.
        var doOne = function (list, workNumber) {
            // Each item must be a promise.
            var deferred = $q.defer();
            // Get the item from the grid.
            var gridItem = list[workNumber];

            scope.processingLabel = loginService.resourceStrings["PROCESSING"] + " " + loginService.resourceStrings["FILENAME"] + ": " + gridItem.selectionItem.filename;

            var timeObj = start();

            //process requiredFields if necessary

            // Check for UndoCheckOut then check file change and data card change.
            var bContinue = true;
            if (gridItem.bUndoCheckOut == "T") {
                if (gridItem.bFileHasChanged == "T") {
                    // This should not happen.
                    $rootScope.msgBoxShow("UndoCheckOut cannot be used with HasFileChanged.", "Internal Error."); // **********
                    // This item is done.
                    deferred.resolve();
                    return deferred.promise;
                }
                else if (gridItem.bDataCardHasChanged == "T") {
                    // If YtoAll, then fall through to checkInItem.
                    if (scope.answers.loseDataCardChanges != 'YtoAll') {
                        if (scope.answers.loseDataCardChanges == 'NtoAll') {
                            deferred.resolve();
                            return deferred.promise;
                        }
                        // Ask 'Are you sure?' with Y/N/YtoAll/NtoAll
                        $rootScope.questionBoxShow(gridItem, deferred, gridItem.selectionItem.filename,
                            loginService.resourceStrings["LOSE_DATA_CARD_CHANGES"], // "Are you sure you want to Release Check Out on an item with data card changes?",
                            loginService.resourceStrings["DATA_CARD_CHANGES_WILL_BE_LOST"], // "Data card changes will be lost. ",
                            questionBox_PostCloseCallback_DataCardChanged)
                        return deferred.promise;
                    }
                }
            }

            // We didn't have to call something that would do the work, 
            // so we have to do it now.
            checkInItem1_TestAccess(gridItem).then(function () {
                end(timeObj, gridItem.selectionItem.filename);
                // When it is done, we are done.
                deferred.resolve();
            }, function () {
                deferred.resolve(); // Called function will not reject.
            });

            // Return the promise for doing the work.
            return deferred.promise;
        }

        // Walk through each item in the grid.
        var doLoop = function (list, workNumber, requiredFieldsData, publishWaveData) {
            // Each item must be a promise.
            var deferred = $q.defer();

            var item = list[workNumber];
            var fileId = item.selectionItem.fileId;
            var majRev = item.selectionItem.majRev;
            var minRev = item.selectionItem.minRev;

            var rfData;
            var operation = 101;
            var title = loginService.resourceStrings["TITLE_CHECKIN"];
            if (requiredFieldsData.checkIn[fileId + majRev + minRev]) {
                rfData = requiredFieldsData.checkIn[fileId + majRev + minRev];

            }
            else if (requiredFieldsData.checkOut[fileId + majRev + minRev] && item.bKeepOut == 'T') {
                rfData = requiredFieldsData.checkOut[fileId + majRev + minRev];
                _updateRequiredFieldsForCheckOut = true;
                operation = 102;
                title = loginService.resourceStrings["TITLE_CHECKOUT"];
            }

            // Skip this item if PW isn't configured for it
            var errorDetails = publishWaveData[item.selectionItem.commandParams.eLibId];
            if (errorDetails != null && errorDetails.ec !== 0) {
                // Add the error to the results list
                item.selectionItem.ec = errorDetails.ec;
                item.selectionItem.errStr = errorDetails.errMsg;
                scope.resultSLX.list.push(item.selectionItem);

                // if it's the last item then return, otherwise increase the number to move on to the next item
                if (workNumber === list.length - 1) {
                    deferred.resolve();
                    return deferred.promise;
                }
                else {
                    // skip to the next item;
                    workNumber++;

                    // Recurse on the next item.
                    doLoop(list, workNumber, requiredFieldsData, publishWaveData).then(function () {
                        // When that is done. Resolve the promise from before.
                        deferred.resolve();
                    }, function () {
                        deferred.resolve(); // Called function will not reject.
                    });
                    return deferred.promise;
                }
            }

            if (_allRequiredFieldsCanceled) {
                rfData = null;
            }

            //process required fields record if necessary
            requiredFieldsService.processRecord(item.selectionItem, rfData, title, operation).then(function (result) {
                var callUpdateDocument = true;
                switch (result) {
                    case "CANCEL":
                    case "ERROR":
                        if (operation === 101) {
                            //if it's the last item then return, otherwise increase the number to move on to the next item
                            if (workNumber === list.length - 1) {
                                deferred.resolve();
                                return;
                            }
                            else {
                                //skip to the next item;
                                workNumber++;

                                // Recurse on the next item.
                                doLoop(list, workNumber, requiredFieldsData, publishWaveData).then(function () {
                                    // When that is done. Resolve the promise from before.
                                    deferred.resolve();
                                }, function () {
                                    deferred.resolve(); // Called function will not reject.
                                });
                                return;
                            }
                        }
                        else {
                            //if the required fields are for checkout then we force the keep out to false
                            list[workNumber].bKeepOut = "F";

                        }
                        break;
                    case "OK":
                        //continue check-in as normal
                        break;
                    case "CANCELALL":
                        //set the rest of the items not to check out
                        if (operation === 101) {
                            deferred.resolve();
                            return;
                        }
                        else {
                            _allRequiredFieldsCanceled = true;
                            break;
                        }                      
                    default:
                        break;
                }

                

                // Do one item.
                doOne(list, workNumber).then(function () {
                    // When that is done, ...
                    // Incement the item number that we are going to work on.
                    workNumber++;
                    // If we are still in the list, ...
                    if (workNumber < list.length) {
                        // Recurse on the next item.
                        doLoop(list, workNumber, requiredFieldsData, publishWaveData).then(function () {
                            // When that is done. Resolve the promise from before.
                            deferred.resolve();
                        }, function () {
                            deferred.resolve(); // Called function will not reject.
                        });
                    }
                    else { // We are done with the list.
                        // Resolve this item.
                        deferred.resolve();
                        // Return the promise.
                        return deferred.promise;
                    }
                }, function () {
                    deferred.resolve(); // Called function will not reject.
                });
            });

            // Return the promise for the current item.
            return deferred.promise;
        }

        // On click OK.
        scope.onCheckInDialogOK = function () {
            // Start working.
            scope.xyz.processing = true;
            scope.answers = {};
            scope.answers.loseDataCardChanges = 'N';
            scope.resultSLX = { mode: 0, order: 0, list: [] };
            scope.resultEmails = [];
            scope.resultNtfItemXfers = [];

            //get a long term
            loginService.setLongTermKey().then(function () {
                // Start the loop.
                var workNumber = 0;
                var timeObj = start();

                //Get required fields info 101 = Check-In
                requiredFieldsService.checkRequiredFields(scope.gridOptions.data, 101).then(function (requiredFieldsData) {

                    requiredFieldsService.checkRequiredFields(scope.gridOptions.data, 102).then(function (rfCheckOutData) {
                        //Get PublishWave info
                        publishWaveService.checkServerConfiguration(scope.gridOptions.data, scope.ACN_SIGN_IN).then(function (publishWaveData) {

                            doLoop(scope.gridOptions.data, workNumber, { checkIn: requiredFieldsData, checkOut: rfCheckOutData }, publishWaveData).then(function () {
                                //console.log(timeObj);
                                end(timeObj, "Total Operation");
                                // Handle errors.
                                var slx = scope.resultSLX;
                                var atLeastOneError = false;
                                angular.forEach(slx.list, function (item) {
                                    if (atLeastOneError == false) {
                                        if (item.ec != 0) {
                                            atLeastOneError = true;
                                            if (atLeastOneError) {
                                                commandService.launchErrors({ slx: slx });
                                                //$rootScope.$broadcast('showErrorList', { slx: response.data });
                                            }
                                        }
                                    }
                                });

                                // Close the dialog when finished.
                                $mdDialog.hide();

                                // Done.
                                scope.xyz.processing = false;
                                gridDataService.updateGridRecords(slx.list);
                                editEmailsService.ProcessNtfItemXfers(scope.resultNtfItemXfers).then(function (data) {
                                    editEmailsService.showEditEmailsDialog(data);
                                    loginService.removeLongTermToken();
                                });

                                //2018 SP1 Refactor: 20180829 - GT
                                //release plugin applications after refresh of extracted data
                                extractionservice.releasePluginApplications();

                            }, function () {
                                scope.xyz.processing = false;
                                loginService.removeLongTermToken();
                            });

                        }, function () {
                            scope.xyz.processing = false;
                            $mdDialog.hide();
                        });
                    });


                });
            });
        }

        // On click Cancel.
        scope.onCheckInDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        // =====================================
        // Grid.
        // =====================================

        // Called after all rows are selected.
        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        // Called after the grid has been initialized.
        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            switch (command) {
                case "checkin":
                    scope.onCheckInButtonClicked(records);
                    break;
            }
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            //useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        // This was an old way of being called by the toolbar.
        //scope.$on('checkInButtonClicked', function (event, arg) {
        //    scope.onCheckInButtonClicked(arg.slx);
        //});

        function start() {
            return { startTime: new Date() };
        };

        function end(timeObj, desc) {
            timeObj.endTime = new Date();
            var timeDiff = timeObj.endTime - timeObj.startTime; //in ms
            // strip the ms
            //timeDiff /= 1000;

            // get seconds 
            var seconds = Math.round(timeDiff);
            console.log(desc + " : " + seconds + " milliseconds");
        }

    }
})();
